import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';

export function usePOIProfilePhoto({ poiId, width, height }: { poiId?: number; width: number; height: number }) {
  const publicBaseUrl = usePublicBaseUrl();

  if (!poiId) {
    return undefined;
  }

  return `${publicBaseUrl}/api/alltrails/points_of_interest/${poiId}/profile_photo?size=${width}w${height}h`;
}
